export const environment = {
  production: false,
  environmentName: 'staging',
  cookieDomain: ".staging.pvbid.com",
  backendApiUrl: 'https://api.staging.pvbid.com/v2/',
  dashboardUrl: 'https://staging.pvbid.com',
  authUrl: 'https://auth.staging.pvbid.com',
  dataMapperUrl: 'https://data-mapper.staging.pvbid.com'
};
